import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function authHeaders() {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    return { Authorization: `Bearer ${token}` };
}

export async function fetchCerfaPrep(dossierId, sourceDocId) {
    const qs = sourceDocId ? `?source_document_id=${encodeURIComponent(sourceDocId)}` : "";
    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/prep${qs}`, { headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function sourceExtract(dossierId, documentId, mode = "historique") {
    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/source-extract?document_id=${encodeURIComponent(documentId)}&mode=${encodeURIComponent(mode)}`, { headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function extractApAsync(dossierId, documentId) {
    const qs = documentId ? `?document_id=${encodeURIComponent(documentId)}` : "";
    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/extract-ap-async${qs}`, { method: "POST", headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function extractApStatus(dossierId, jobId) {
    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/extract-ap-status?job_id=${encodeURIComponent(jobId)}`, { headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

// SUPER-LOT 92 — Extraction P&L historique (N-1 / 3 mois) STRICTEMENT asynchrone (202 + polling).
export async function extractPnlAsync(dossierId, documentId) {
    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/previsionnels/extract-pnl-async?document_id=${encodeURIComponent(documentId)}`, { method: "POST", headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

// HOTFIX 90 — Polling générique des tâches de fond (202 + polling) : { status, data, error }.
export async function taskStatus(taskId, dossierId) {
    const qs = dossierId ? `?dossier_id=${encodeURIComponent(dossierId)}` : "";
    const r = await fetch(`${BASE}/api/tasks/status/${encodeURIComponent(taskId)}${qs}`, { headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function fetchHistoriquePrefill(dossierId) {
    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/historique-prefill`, { headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function fetchBalanceTotal(dossierId, kind = "fournisseur") {    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/balance-total?kind=${encodeURIComponent(kind)}`, { headers: await authHeaders() });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function saveCerfaPrep(dossierId, payload) {    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/prep`, {
        method: "PUT", headers: { ...(await authHeaders()), "Content-Type": "application/json" }, body: JSON.stringify(payload),
    });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export async function downloadCerfaPdf(dossierId) {    const r = await fetch(`${BASE}/api/dossiers/${dossierId}/cerfa-10530/pdf`, { headers: await authHeaders() });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Formulaire_DCP.pdf";
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    a.click();
    URL.revokeObjectURL(url);
    return blob;
}
